/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React from 'react';
import Checkbox1 from './Checkbox';

import { status } from './constant';

export default function List(props) {
    const {
        items, compute, Segments, handleCheckBox,
    } = props;
    return (
        <ul>
            {items && items.map((item) => {
                let childList = null;
                if (item.items && Array.isArray(item.items) && item.items.length > 0 && Segments?.includes(item.id)) {
                    childList = (
                        <List
                            items={item.items}
                            compute={compute}
                            Segments={Segments}
                            handleCheckBox={handleCheckBox}
                        />
                    );
                }

                const IsChecked = (item) => {
                    let state = false;
                    if (item.status === status.checked) {
                        state = true;
                    }
                    if (item.status === status.indeterminate) {
                        state = true;
                    }
                    return state;
                };

                return (
                    <div key={item.id} className="pl-6 relative">
                        <button className="pl-3 pt-3 categories transition duration-150 ease-in-out flex items-center drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat1" aria-expanded="false" aria-controls="collapsecat1" style={{ cursor: 'pointer' }}>
                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                <Checkbox1
                                    id={item.id}
                                    name={item.name}
                                    checked={IsChecked(item)}
                                    // indeterminate={item.status === status.indeterminate}
                                    compute={compute}
                                />
                                <label htmlFor={`${item.name}`} />
                                {' '}
                                <p
                                    className={`pl-3 text-sm cursor-pointer ${Segments?.includes(item.id) ? 'text-[#555259] font-bold' : 'text-[#808285] font-normal'}`}
                                    onClick={() => item?.items.length > 0 && handleCheckBox(item.id, 'segments')}
                                >
                                    {`${item?.name === 'MNR' ? 'MnR' : item.name}`}
                                </p>
                                {item?.items?.length > 0 && (
                                    <img
                                        onClick={() => item?.items.length > 0 && handleCheckBox(item.id, 'segments')}
                                        src="/images/Arrow_down.svg"
                                        alt="icon"
                                        className={`ml-1.5 drop-btn ${Segments?.includes(item.id) ? 'show image-rotate' : ''}`}
                                    />
                                )}
                            </div>
                        </button>
                        {childList}
                    </div>
                );
            })}
        </ul>
    );
}
